<div class="sidebar">
  <div class="cart-detail-box">
    <div class="card">
      <div class="card-header padding-15 fw-700">Your Order</div>
      <div class="card-body no-padding" id="scrollstyle-4">
        <!-- Empty Cart -->
        <div
          *ngIf="isCartEmpty$ | async"
          class="text-center"
          style="padding: 40px"
        >
          <p class="text-light-black">Your cart is empty</p>
        </div>

        <!-- Cart Items by Store -->
        <ng-container *ngFor="let storeCart of storeCarts$ | async">
          <div *ngFor="let item of storeCart.items" class="cat-product-box">
            <div class="cat-product">
              <div class="cat-name">
                <a href="javascript:void(0)">
                  <p class="text-light-green fw-700">
                    <span class="text-dark-white">1</span>
                    {{ getItemDescription(item) }}
                  </p>
                  <span class="text-light-white fw-700" *ngIf="item.duration">
                    Duration: {{ item.duration }} min
                  </span>
                </a>
              </div>
              <div class="delete-btn">
                <a
                  href="javascript:void(0)"
                  class="text-dark-white"
                  (click)="removeCartItem(storeCart.storeId, item.id)"
                  (touchend)="
                    removeCartItem(storeCart.storeId, item.id);
                    $event.preventDefault()
                  "
                  title="Remove item"
                  style="cursor: pointer"
                >
                  <i class="far fa-trash-alt"></i>
                </a>
              </div>
              <div class="price">
                <a href="javascript:void(0)" class="text-dark-white fw-500">
                  {{ formatPrice(item.totalPrice) }}
                </a>
              </div>
            </div>
          </div>
        </ng-container>

        <div class="item-total" *ngIf="!(isCartEmpty$ | async)">
          <div class="total-price border-0">
            <span class="text-dark-white fw-700">Items subtotal:</span>
            <span class="text-dark-white fw-700">{{
              cartTotalPrice$ | async | currency : "USD" : "symbol" : "1.2-2"
            }}</span>
          </div>
          <div class="empty-bag padding-15 fw-700">
            <a
              href="javascript:void(0)"
              (click)="clearCart()"
              (touchend)="clearCart(); $event.preventDefault()"
              style="cursor: pointer"
              >Empty bag</a
            >
          </div>
        </div>
      </div>
      <div class="card-footer padding-15" *ngIf="!(isCartEmpty$ | async)">
        <button
          class="btn btn-primary text-custom-white full-width fw-500"
          (touchend)="proceedToCheckout(); $event.preventDefault()"
          (click)="proceedToCheckout()"
        >
          Book now
        </button>
      </div>
    </div>
  </div>
</div>
